<template>
  <v-menu offset-y>
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" :color="color" text>
        <v-icon small class="pr-1">fa-calendar-alt</v-icon>
        <span v-if="temporada" class="pr-1 text-none hidden-sm-and-down">{{
          temporada.nombre
        }}</span>
      </v-btn>
    </template>
    <v-list
      :class="{ 'hidden-sm-and-up': isFilteredListaTemporadaEmpty }"
      class="fh-menu-scroll"
    >
      <v-list-item :color="colorXs" class="hidden-sm-and-up">
        <v-list-item-title v-if="temporada">{{
          temporada.nombre || "Elija Temporada"
        }}</v-list-item-title>
      </v-list-item>

      <v-divider
        v-if="!isFilteredListaTemporadaEmpty"
        class="hidden-sm-and-up"
      ></v-divider>

      <template v-if="!isFilteredListaTemporadaEmpty">
        <v-list-item
          v-for="temporada in filteredListaTemporadaAgricultor"
          :key="temporada.idTemporada"
          @click="handleElegirTemporada(temporada.idTemporada)"
        >
          <v-list-item-title>{{ temporada.nombre }}</v-list-item-title>
        </v-list-item>
      </template>
    </v-list>
  </v-menu>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
  name: "FhMenuTemporada",
  computed: {
    ...mapState("temporada", ["temporada", "temporadaActual"]),
    ...mapState("session", ["isRestored"]),
    ...mapGetters("temporada", [
      "isTemporadaSet",
      "getTemporadaAgricultor",
      "filteredListaTemporadaAgricultor",
    ]),
    ...mapGetters("establecimientos", [
      "hasCategoriaAgricultura",
      "hasCategoriaGanaderia",
      "currentCategoria",
    ]),
    isFilteredListaTemporadaEmpty() {
      return this.filteredListaTemporadaAgricultor.length === 0;
    },
    color() {
      return !this.temporada?.temporadaHabilitada ? "orange darken-2" : "";
    },
    colorXs() {
      return !this.temporada?.temporadaHabilitada ? "orange darken-2" : "green";
    },
  },
  methods: {
    ...mapActions("temporada", [
      "setTemporada",
      "fetchListaTemporadaAgricultor",
      "fetchTemporadaActual",
    ]),
    async handleElegirTemporada(id) {
      let temporada = this.getTemporadaAgricultor(id);

      await this.setTemporada(temporada);
      if (this.currentCategoria === 1 && this.hasCategoriaAgricultura) {
        this.$router.push({ name: "AgroHome" }).catch(() => {});
      } else {
        this.$router.push({ name: "GanaderiaHome" }).catch(() => {});
      }
    },
  },
  async created() {
    // To prevent a race condition when session isn't restored yet
    while (!this.isRestored) {
      await this.$sleep(10);
    }

    await this.fetchListaTemporadaAgricultor();
    await this.fetchTemporadaActual();
  },
};
</script>

<style scoped>
.fh-menu-scroll {
  overflow-y: auto;
  max-height: 90vh;
}
</style>
